// src/contexts/ErrorContext.jsx
import React, { createContext, useContext, useState } from 'react';
import ErrorDialog from '../components/ErrorDialog';

const ErrorContext = createContext();

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError must be used within ErrorProvider');
  }
  return context;
};

export const ErrorProvider = ({ children }) => {
  const [error, setError] = useState(null);

  const showError = (errorData) => {
    setError(errorData);
  };

  const clearError = () => {
    setError(null);
  };

  return (
    <ErrorContext.Provider value={{ showError, clearError }}>
      {children}
      <ErrorDialog error={error} onClose={clearError} />
    </ErrorContext.Provider>
  );
};